import React from 'react';

import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Paper,
  Typography,
  Divider,
} from '@material-ui/core';

import * as constants from '../../config/constants';
import * as routes from '../../config/routes';
import DashNav from './DashNav';

import classes from '../../css/getCSS';

const LeftPanel = (props) => {
  const avatarURL = constants.BASE_URL + props.user.avatar_md;
  return (
    <Paper elevation={0} className={[classes.boxShadow, classes.borderRadius2].join(' ')}>
      <Link
        to={formatRoute(routes.VIEW_PROFILE, { uuid: props.user.slug })}
        className={classes.linkDeCSS}
      >
        <div className={classes.sideAvatarWrapper}>
          <img src={avatarURL} alt={props.user.first_name} className={classes.leftAvatar} />
          <Typography variant="title">{props.user.first_name} {props.user.last_name}</Typography>
          <Typography variant="title">{props.user.profile_id}</Typography>
        </div>
      </Link>
      <Divider />
      <DashNav user={props.user} dashActiveLink={props.dashActiveLink} />
    </Paper>
  );
};

export default LeftPanel;



// WEBPACK FOOTER //
// ./src/dashboard/components/LeftPanel.js